<template>
  <div>
    <b-overlay :show="dataLoading" spinner-variant="primary" variants="white" opacity="0.6">
      <vs-col v-for="(config, index) in configs" :key="index" vs-w="12">
        <b-card no-body>
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>
                {{ config.instagramHandle }}
              </b-card-title>
            </div>
              <b-dropdown
              variant="link"
              no-caret
              right
              class="chart-dropdown"
              toggle-class="p-0"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item
                @click="goToConfigEdit(config.configId)"
              >
                {{ $t("socialStream.configsList.edit") }}
              </b-dropdown-item>
              <b-dropdown-item
                @click="goToCatalogs(config.configId)"
              >
                {{ $t("socialStream.configsList.assignCatalogs") }}
              </b-dropdown-item>
              <b-dropdown-item
                @click="goToDefaultProducts(config.configId)"
              >
                {{ $t("socialStream.configsList.defaultProducts") }}
              </b-dropdown-item>
              <b-dropdown-item
                @click="goToViewPosts(config.configId)"
              >
                {{ $t("socialStream.configsList.viewPosts") }}
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body>
            <dl class="row mb-1 mb-md-0">
              <dt class="col-sm-3">
                {{ $t("socialStream.configsList.header.id") }}
              </dt>
              <dd class="col-sm-9">
                {{ config.configId }}
              </dd>
            </dl>
            <dl class="row mb-1 mb-md-0">
              <dt class="col-sm-3">
                {{ $t("socialStream.configsList.header.instagramPostsCatalog") }}
              </dt>
              <dd class="col-sm-9">
                {{ config.instagramPostsCatalogName ? config.instagramPostsCatalogName : $t("socialStream.configsList.unassigned") }}
              </dd>
            </dl>
            <dl class="row mb-1 mb-md-0">
              <dt class="col-sm-3">
                {{ $t("socialStream.configsList.header.productsCatalog") }}
              </dt>
              <dd class="col-sm-9">
                {{ config.productsCatalogName ? config.productsCatalogName : $t("socialStream.configsList.unassigned") }}
              </dd>
            </dl>
          </b-card-body>
        </b-card>
      </vs-col>
    </b-overlay>
  </div>
</template>

<script>
import SocialStreamConfigsStore from '@/store/socialStream/socialStreamConfigs'

export default {
  computed: {
    configs() {
      return SocialStreamConfigsStore.state.socialStreamConfigs.configs
    },
    dataLoading() {
      return SocialStreamConfigsStore.state.dataLoading
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      return SocialStreamConfigsStore.dispatch('getSocialStreamConfigsData')
    },
    goToConfigEdit(configId) {
      this.$router.push({ name: 'socialStreamConfig', params: { configId } })
    },
    goToCatalogs(configId) {
        this.$router.push({ name: 'socialStreamCatalogs', params: { configId } })
    },
    goToViewPosts(configId) {
        this.$router.push({ name: 'socialStreamPosts', params: { configId } })
    },
    goToDefaultProducts(configId) {
        this.$router.push({ name: 'socialStreamDefaultProducts', params: { configId } })
    },
  },
}
</script>

